import { t } from '@transifex/native';

import { show } from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import { create } from 'pkg/api/models/actions';
import * as sdk from 'pkg/core/sdk';

export const newActivity = async (
	organizationId: number,
	userId: number,
	data: unknown
) => {
	const [request] = await create(
		endpoints.UserActivities.Create(organizationId, userId),
		data
	);
	if (!request.ok) {
		return;
	}

	show(
		{
			title: t(`Activity saved`),
			message: t(`Training activity saved successfully, well done!`),
		},
		200
	);
};

export const updateActivity = async (
	organizationId: number,
	activityId: number,
	data: unknown
) => {
	const req = await sdk.patch(
		endpoints.UserActivities.Update(organizationId, activityId),
		{},
		data
	);
	if (!req.ok) {
		return;
	}

	show(
		{
			title: t(`Activity saved`),
			message: t(`Training activity updated`),
		},
		200
	);
};

export const removeActivity = async (
	organizationId: number,
	activityId: number
) => {
	const req = await sdk.destroy(
		endpoints.UserActivities.Delete(organizationId, activityId)
	);
	if (!req.ok) {
		return;
	}
};
